import { initialState } from '../interfaces/initialState'
import IState from '../interfaces/IState'

import {
  ActionTypes,
  GET_HR_USERS_FAILURE,
  GET_HR_USERS_REQUEST,
  GET_HR_USERS_SUCCESS,
} from './ActionTypes'

export const hrUsersReducer = (
  state: IState = initialState,
  action: ActionTypes,
): IState => {
  switch (action.type) {
    case GET_HR_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case GET_HR_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.users,
      }
    case GET_HR_USERS_FAILURE:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}
